exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html{overflow-y:auto!important}div.d-flex.header-wrapper>header.bkg-default{position:static}", ""]);
